import { Component, inject, Input, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { NavService } from '../../../../../_services/_nav.service';
import { ObligacionesVigentes } from '../../../../../_models/perfil-cliente/obligaciones-vigentes';
import { PerfilCrezcamosCreditosFirmantesReferenciasComponent } from './firmantes-referencia/perfil-crezcamos-creditos-firmantes-referencias.component';
import moment from 'moment';

@Component({
  selector: 'app-perfil-crezcamos-creditos-vigentes',
  templateUrl: './perfil-crezcamos-creditos-vigentes.component.html',
  styleUrls: ['./perfil-crezcamos-creditos-vigentes.component.scss']
})
export class PerfilCrezcamosCreditosVigentesComponent implements OnInit {
  @Input() informacionPerfil: any;
  columnasObligacionesVigentes: any[];
  public banMensaje: boolean = false;
  public obligacionesVigentes: ObligacionesVigentes[] = [];

  private navServicio = inject( NavService );
  private diaService = inject( DialogService );

  ngOnInit(): void {
    if ( !this.informacionPerfil ) {
      this.banMensaje = true;
      return;
    }

    this.obligacionesVigentes = this.informacionPerfil.obligacionesVigentes;
    this.ordenarDatos();
    console.log('this.obligacionesVigentes', this.obligacionesVigentes);
    this.cargarTabla();
  }

  async cargarTabla() {
    this.columnasObligacionesVigentes = [
      { field: 'participacion', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_PARTICIPACION'), sort: false },
      { field: 'numeroCredito', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_NUMERODECREDITO'), sort: false },
      { field: 'diasMora', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_DIASMORA'), sort: false },
      { field: 'montoDesembolso', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_MONTODESEMBOLSADO'), sort: false },
      { field: 'cuota', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_CUOTA'), sort: false },
      { field: 'plazo', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_PLAZO'), sort: false },
      { field: 'tasaEA', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_TASAEA'), sort: false },
      { field: 'frecuenciaPago', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_AMORTIZACION'), sort: false },
      { field: 'fechaDesembolso', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_FECHADESEMBOLSO'), sort: false },
      { field: 'saldoCapital', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_CAPITAL'), sort: false },
      { field: 'pagoTotal', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_PAGOTOTAL'), sort: false },
      { field: 'pagoTotal', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_VALORMORA'), sort: false },
      { field: 'altura', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_ALTURA'), sort: false },
      { field: 'moraMaxima', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_MORAMAXIMA'), sort: false },
      { field: 'liquidacion', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_LIQUIDEZ'), sort: false },
      { field: 'ingresos', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_INGRESOS'), sort: false },
      { field: 'activos', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_ACTIVOS'), sort: false },
      { field: 'patrimonio', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_PATRIMONIO'), sort: false },
      { field: 'garantia', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_GARANTIA'), sort: false },
      { field: 'acciones', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_FIRMANTES'), sort: false }
    ];
  }

  transformDate(fecha: string): Date | null {
    if (!fecha) return null;
    const fechaFormateada = moment(fecha, "DD-MM-YYYY");
    return fechaFormateada.isValid() ? fechaFormateada.toDate() : null;
  }

ordenarDatos(): void {
    const orderParticipacion = { 'TIT': 1, 'SOL': 2, 'COD': 3 };
    const orderFirmantes = { 'TITULAR': 1, 'DEUSO': 2, 'CODDEU': 3 };

    this.obligacionesVigentes = this.obligacionesVigentes.sort((a, b) => {
      return (orderParticipacion[a.participacion] || 4) - (orderParticipacion[b.participacion] || 4);
    }).map(item => {
      item.firmantes.sort((a, b) => {
        return (orderFirmantes[a.codigoVinculacion] || 4) - (orderFirmantes[b.codigoVinculacion] || 4);
      });
      return item;
    });
  }

 visualizarFirmantes( row: any ) {
    const modal = this.diaService.open(PerfilCrezcamosCreditosFirmantesReferenciasComponent, {
      header: this.navServicio.buscarMensaje( 'PERFILCREZCAMOS.LBL_FIRMANTESOBLIGACION' ),
      closeOnEscape: true,
      width: '70%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      maximizable: false,
      data: {
        row: row
      }
    });
    modal.onClose.subscribe((data: any) => {
    });
  }
 }
